export default "/assets/site/images/janosne_gabi.png?b63596a703a8c121f75a6323970b78ff";